var map = {
	"./bag.png": "7e8a",
	"./baklava.png": "ae97",
	"./bohodiamond.png": "d4c0",
	"./candycane.png": "da47",
	"./car.png": "d480",
	"./champagne.png": "da31",
	"./cheers.png": "1252",
	"./christmashat.png": "822d",
	"./christmassweater.png": "ca21",
	"./christmastree.png": "cc57",
	"./cocktail.png": "4bd3",
	"./dollarcoin.png": "1193",
	"./donut.png": "7ef6",
	"./evileyetalisman.png": "a6ee",
	"./happynewyear.png": "9a4a",
	"./hookah.png": "0958",
	"./hug.png": "f868",
	"./key.png": "0661",
	"./love-balloon.png": "6203",
	"./necklace.png": "6b61",
	"./newyear.png": "cecf",
	"./noelcouple.png": "e2b4",
	"./orchid.png": "7c36",
	"./snowman.png": "a2c7",
	"./star.png": "4c66",
	"./teddy-bear.png": "7096",
	"./woman_gift.png": "afe8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "888c";